import { useEffect, useState, useRef } from 'react'
import { useInView } from 'framer-motion'

export function useAnimatedCounter(targetValue: number, duration: number = 2) {
  const [count, setCount] = useState(0)
  const ref = useRef(null)
  const isInView = useInView(ref, { once: true, margin: '-50px' })

  useEffect(() => {
    if (isInView) {
      let startTimestamp: number
      const step = (timestamp: number) => {
        if (!startTimestamp) startTimestamp = timestamp
        const progress = Math.min(
          (timestamp - startTimestamp) / (duration * 1000),
          1,
        )

        // Ease out quad
        const easeProgress = progress * (2 - progress)

        setCount(Math.floor(easeProgress * targetValue))

        if (progress < 1) {
          window.requestAnimationFrame(step)
        } else {
          setCount(targetValue)
        }
      }
      window.requestAnimationFrame(step)
    }
  }, [isInView, targetValue, duration])

  return { count, ref }
}
